export default __webpack_public_path__ + "static/media/step-4-of-4.97101585.gif";